export default {"src":"/_next/static/media/act.f7ac9ead.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};